import styles from './Author.module.scss'
import { AuthorProps } from './types'
import { Img } from '@boltenergy-be/design-system'

const Author = ({ name, date, imagePublicId }: AuthorProps) => {
  return (
    <figure className={styles['author-container']}>
      {imagePublicId && <Img publicId={imagePublicId} width={48} height={48} alt={name} className={styles.avatar} />}
      <figcaption className={styles.caption}>
        <time>{date}</time>
        <strong className={styles.author}>{name}</strong>
      </figcaption>
    </figure>
  )
}

export default Author
